import React from 'react';
import type { MapProps as _MapProps, MapRef, MarkerProps } from 'react-map-gl';
import _Map from 'react-map-gl/dist/esm/components/map';
import _Marker from 'react-map-gl/dist/esm/components/marker';

/**
 * The react-map-gl components without the package entry.
 *
 * `react-map-gl/dist/esm/exports-mapbox.js` runs `import('mapbox-gl')` as soon
 * as it is evaluated, which is at page load since the views import it
 * statically. When that fetch fails the rejection is unhandled and the promise
 * stays rejected for the page lifetime, so no map can mount until the next
 * reload (VIU-703). Importing the components from their own modules skips the
 * entry; `Map` has no default lib and requires `mapLib` (see loadMapbox). Type
 * imports from 'react-map-gl' are erased at build time and do not evaluate it.
 *
 * react-map-gl 8 imports mapbox-gl statically; this file can go with that
 * upgrade.
 */
export type MapProps = _MapProps & Required<Pick<_MapProps, 'mapLib'>>;

export const Map = React.forwardRef<MapRef, MapProps>((props, ref) =>
  _Map(props, ref, props.mapLib),
);

export const Marker = _Marker;

export type { MapRef, MarkerProps };
